// src/store/modal-store.ts
import { create } from 'zustand';
import React from 'react';

interface ModalState {
  isOpen: boolean;
  title: string;
  content: React.ReactNode | null;
  openModal: (title: string, content: React.ReactNode) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  isOpen: false,
  title: '',
  content: null,
  openModal: (title, content) => set({ isOpen: true, title, content }),
  closeModal: () => set({ isOpen: false, title: '', content: null }),
}));